import styled from "styled-components";
import {styledByTheme} from "../../../../themes/architecture/styled-by-theme";

const ProfilePictureDefaultBox = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: -4.5rem 0 2rem 0;

    @media ${({theme}) => theme.mediaQuery.xlAndBelow}, ${({theme}) => theme.mediaQuery.lowHeight} {
        margin-bottom: 0.5rem;
    }
`;

const ProfilePictureMrGreenBox = styled(ProfilePictureDefaultBox)`
    margin-bottom: 0;
`;

export const ProfilePictureBox = styledByTheme(ProfilePictureDefaultBox).forMrGreen(ProfilePictureMrGreenBox).apply();